import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../../lib/gsap";

export default class Navs {
    static init() {
        this.header = document.querySelector(".header-main");

        if (this.header) {
            this.overlay = document.querySelector(".overlay");
            this.navBg = this.header.querySelector(".header-main-bg");
            this.toggleMobileNav();
            this.initMegaMenu();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeMobileNav();
                } else {
                    this.openMobileNav();
                }
            });
        }

        const closeLevel2 = document.querySelectorAll('.js-menu-back');
        closeLevel2.forEach( item => {
           item.addEventListener('click', () => {
               this.closeAllLev2();
           });
        });
    }

    static openMobileNav() {
        document.body.classList.add("navs-open");
        GlobalVariables.lenis?.stop();
    }

    static closeMobileNav() {
        document.body.classList.remove("navs-open");
        this.closeAllLev2();

        const activeMenuItems = this.header.querySelectorAll(".menu-item-lev1.active");
        activeMenuItems.forEach(item => {
            item.classList.remove("active");
            const subnav = item.querySelector(".lev2");
            if( subnav ) {
                subnav.classList.remove("show");
            }
        });

        GlobalVariables.lenis?.start();
    }

    static initMegaMenu() {
        // Un clic sur l'overlay ferme tout
        this.overlay.addEventListener("click", () => {
            this.closeAllLev2();
            this.closeMobileNav();
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                this.closeAllLev2();
                this.closeMobileNav();
            }
        });

        this.navMain = this.header.querySelector(".nav-main");
        this.levelOneItems = this.navMain.querySelectorAll(".menu-item-lev1.menu-item-has-children");

        this.levelOneItems.forEach(levelOne => {
            levelOne.toggle = levelOne.querySelector("button[data-header='toggler']");
            levelOne.levelTwo = levelOne.querySelector(".lev2-items");

            if (!levelOne.levelTwo) {
                return;
            }

            levelOne.toggle.addEventListener("click", (e) => {
                e.preventDefault();

                if (levelOne.classList.contains("active")) {
                    document.body.classList.remove("subnav-open");
                    this.navMain.classList.remove("subnav-active");
                    this.adjustNavBg(levelOne.levelTwo);
                    levelOne.classList.remove("active");
                    levelOne.levelTwo.classList.remove("show");
                    levelOne.toggle.setAttribute("aria-expanded", false);

                    if (window.innerWidth > 991) {
                        GlobalVariables.lenis?.start();
                    }
                } else {
                    this.closeAllLev2();

                    document.body.classList.add("subnav-open");
                    this.navMain.classList.add("subnav-active");
                    this.adjustNavBg(levelOne.levelTwo);
                    levelOne.classList.add("active");
                    levelOne.levelTwo.classList.add("show");
                    levelOne.toggle.setAttribute("aria-expanded", true);

                    if (window.innerWidth > 991) {
                        GlobalVariables.lenis?.stop();
                    }
                }
            });
        });
    }

    static closeAllLev2() {
        document.body.classList.remove("subnav-open");
        this.navMain.classList.remove("subnav-active");
        this.levelOneItems.forEach(item => {
            item.classList.remove("active");
            item.levelTwo.classList.remove("show");
            item.querySelector("button[data-header='toggler']").setAttribute("aria-expanded", "false");
        });

        if (window.innerWidth > 991) {
            GlobalVariables.lenis?.start();
        }
    }

    static restoreNav() {
        this.closeAllLev2();
        this.closeMobileNav();
    }

    static adjustNavBg(levelTwo) {
        if (window.innerWidth > 991) {
            const navBg = this.header.querySelector(".nav-main .nav-main-bg");
            gsap.to(navBg, {duration: 0.3, height: levelTwo.offsetHeight});
        }
    }

    static resize() {
        this.restoreNav();
    }
}